import Axios from "./axios";

export const API_VERSIONS = {
  v0: "v0",
} as const;

let instance: Axios | null = null;

const getAxiosInstance = (): Axios => {
  if (!instance) {
    instance = new Axios();
  }

  return instance;
};

const api = getAxiosInstance();

export default api;
